module.exports = __webpack_public_path__ + "img/Villa_Borna_52.f8809097.jpg";